export const DEFAULT_PAGE_SIZE = 12;

const queryParam = (url, name) => {
  const match = String(url || "").match(new RegExp(`[?&]${name}=(\\d+)`));
  return match ? parseInt(match[1], 10) : null;
};

const pageSizeFromLinks = (next, prev) => {
  const limit = queryParam(next, "limit") || queryParam(prev, "limit");
  return limit > 0 ? limit : null;
};

export const currentPageFromLinks = (next, prev) => {
  const limit = pageSizeFromLinks(next, prev);
  if (limit) {
    if (next) {
      const offset = queryParam(next, "offset");
      if (offset !== null) return Math.max(1, Math.round(offset / limit));
    }
    if (prev) {
      return Math.round((queryParam(prev, "offset") || 0) / limit) + 2;
    }
  }
  if (next) {
    const page = queryParam(next, "page");
    if (page !== null) return Math.max(1, page - 1);
  }
  if (prev) {
    const page = queryParam(prev, "page");
    return page !== null ? page + 1 : 2;
  }
  return 1;
};

export const totalPagesFromCount = (count, next, prev, pageSize) =>
  Math.max(
    1,
    Math.ceil(count / (pageSizeFromLinks(next, prev) || pageSize || DEFAULT_PAGE_SIZE))
  );
